export default "__VITE_PUBLIC_ASSET__447dc2c5__"